import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';

import { Footer } from 'src/components/footer';
import { Navbar } from 'src/components/navbar';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <Navbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </QueryClientProvider>
  );
}
